import { getNaqSelfServiceFeature } from '@dispatch/shared/services';
import { useQuery } from '../useQuery';
import { isEmpty } from 'lodash';

export const useGetNaqSelfServiceFeature = (
  tenantId: string,
  enabled = true
) => {
  const { data, status, refetch } = useQuery(
    ['naq-self-service-feature'],
    () => getNaqSelfServiceFeature(tenantId),
    {
      enabled: enabled && !isEmpty(tenantId),
    }
  );

  return {
    feature: data || false,
    featureStatus: status,
    fetchFeature: refetch,
  };
};
